<template>
  <v-date-picker
  :first-day-of-week="1"
    elevation="15"
    range
    v-model="dates"
    color="primary"
    header-color="primary"
  ></v-date-picker>
</template>

<script>
export default {
  name: "AttendanceDatePicker",
  props: {},
  data() {
    return {
      dates: [],
    };
  },
  computed: {},
  watch: {
    dates: function (val) {
      this.$emit("updateDate", val);
    },
  },

  methods: {},
};
</script>
